import { IStoreCouponState } from "~/types/store/coupon";

const state: () => IStoreCouponState = () => ({
    coupons: [],
    active: null,
});

export default state;
